import ShareButtons from '../components/elements/ShareButtons';

if (document.getElementById('share-buttons')) {
  new Vue({
    el: '#share-buttons',
    components: {
      ShareButtons
    },
  });
}
